// GTM Events
export const GTM_RECAPTCHA_EVENTS = Object.freeze({
  HUMAN_NO_CAPTCHA_NEEDED: 'HUMAN_NO_CAPTCHA_NEEDED',
  HUMAN_CAPTCHA_SUCCESS: 'HUMAN_CAPTCHA_SUCCESS',
  OPEN_MODAL: 'OPEN_MODAL',
  CAPTCHA_FAILED: 'CAPTCHA_FAILED',
  CLOSE_MODAL: 'CLOSE_MODAL',
  API_CALL: 'API_CALL',
  RECAPTCHA_ERROR: 'RECAPTCHA_ERROR'
});

export const GTM_API = Object.freeze({
  customerVehicles: 'customerVehicles',
  confirm: 'confirm',
  reschedule: 'reschedule',
  registerUser: 'registerUser',
  cancel: 'cancel'
});



// WEBPACK FOOTER //
// ./src/constants/recaptcha.js